import React from 'react'
import { Updater, fromJSX, Widget, any } from 'widgets-for-react'
import { InviewProps } from '../blocksState'
import { LogoSliderLayout } from './logoSliderLayout'
import { LogoSliderState } from './logoSliderState'

export type LogoSliderBlock = {
  index: number
  inview?: InviewProps
  logoSliderState: LogoSliderState
}

export const logoSliderBarWidget = ( block: LogoSliderBlock ): Widget<Updater<LogoSliderState>> => {
  return any<Updater<LogoSliderState>>([
    fromJSX(setState => (
      <LogoSliderLayout
        {...block}
        items={block.logoSliderState.items}
      />
    ))
  ])
}
